import React from "react";

export const ReactContext = React.createContext({});
export const Provider = ReactContext.Provider;
export const Consumer = ReactContext.Consumer;
